export default {"src":"/_next/static/media/upload-white.e68b14d4.svg","height":30,"width":30};